import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
let WProgress = class WProgress extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "percentage", void 0);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "strokeWidth", void 0);
    _defineProperty(this, "textInside", void 0);
    _defineProperty(this, "showText", void 0);
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "color", void 0);
    _defineProperty(this, "dataTest", void 0);
  }
};
__decorate([Prop({
  default: 0
})], WProgress.prototype, "percentage", void 0);
__decorate([Prop({
  default: 'line'
})], WProgress.prototype, "type", void 0);
__decorate([Prop({
  default: 6
})], WProgress.prototype, "strokeWidth", void 0);
__decorate([Prop({
  default: false
})], WProgress.prototype, "textInside", void 0);
__decorate([Prop({
  default: true
})], WProgress.prototype, "showText", void 0);
__decorate([Prop({
  default: ''
})], WProgress.prototype, "status", void 0);
__decorate([Prop({
  default: ''
})], WProgress.prototype, "color", void 0);
__decorate([Prop()], WProgress.prototype, "dataTest", void 0);
WProgress = __decorate([Component({})], WProgress);
export default WProgress;